module.exports = __webpack_public_path__ + "static/usc-39582f75de8aab3c629dd07eb46768a9.png";